/* eslint-disable no-console */
import {
  call, put, select,
} from 'redux-saga/effects';
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import * as actions from '../state';

// eslint-disable-next-line import/prefer-default-export
export function* fetchPremiumCreds() {
  const userObj = yield select((state) => actions.readStateUser(state));  
  const iotumVideoEnabled = yield select((state) => actions.selectConfig(state, 'PORTAL_PREMIUM_VIDEO_ENABLED'));
  if (iotumVideoEnabled && iotumVideoEnabled === 'yes') {
    const domain = yield call(nsApi.v2, {
      object: 'video',
      action: 'get',
    }, `domains/${userObj.domain}`);

    let videoDomainSuspended = false;
    let iotumVideoStatus = {};
    if (domain['iotum-video-status'] !== 'active') {
      iotumVideoStatus = domain['iotum-video-status']
        ? JSON.parse(domain['iotum-video-status'] || '{}')
        : {};
    }
    if (iotumVideoStatus?.status === 'suspended') {
      videoDomainSuspended = true;
    }

    if (!domain.iotum_company_id || videoDomainSuspended) {
      yield put(actions.setConfig({ premiumVideoConfigured: false }));
      return;
    }

    try {
      const iotumHost = yield call(nsApi.v2, {
        object: 'video',
        action: 'get',
      }, `domains/~/users/${userObj.userId}/video`);
      console.debug('iotum host:', iotumHost);
      if (iotumHost.error_code) {
        console.error('Invalid host:', iotumHost);
        return;
      }
      if (!iotumHost['plan-slug']) {
        console.log('Host not enabled with Video plan'); // eslint-disable-line no-console
        yield (put(actions.setConfig({ PORTAL_VIDEO: 'no' })));
        return;
      }
      yield put(actions.setConfig({ premiumVideoConfigured: true }));
      let url = `https://${iotumHost.iotum_domain}/auth?`;
      url += `host_id=${iotumHost.host_id}`;
      url += `&login_token_public_key=${iotumHost.login_token_public_key}`;
      url += '&redirect_url=conf/conferences/create?events=false';
      yield put(actions.setConfig({ premiumVideoURL: url }));
    } catch (e) {
      console.error(e);
      console.debug('error in fetchVideoCreds e: ', e);
    }
  }
}
